import React from "react";
import { menuSurgery } from "./Datamenu_inc";
import { motion } from "framer-motion";

export const DataSurgery_1 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
        <span className="drop-shadow-lg">{menuSurgery[0].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ผ่าตัดทำหมันทั่วไป:
          การผ่าตัดทำหมันเพื่อควบคุมการขยายพันธุ์และลดความเสี่ยงของโรคบางชนิด
        </li>
        <li>
          ผ่าตัดระบบทางเดินอาหารและช่องท้อง: เช่น การผ่าตัดกระเพาะอาหาร, ลำไส้,
          และถุงน้ำดี
        </li>
        <li>
          ผ่าตัดระบบทางเดินปัสสาวะ: เช่น การผ่าตัดไต, กระเพาะปัสสาวะ,
          และท่อปัสสาวะ
        </li>
        <li>
          ผ่าตัดเนื้องอก: การผ่าตัดเพื่อกำจัดเนื้องอกหรือมะเร็งในส่วนต่างๆ
          ของร่างกาย
        </li>
        <li>
          ผ่าตัดระบบทางเดินสืบพันธุ์: เช่น การผ่าตัดมดลูก, รังไข่, และท่อนำไข่
        </li>
        <li>เย็บแผลทั่วไป: การเย็บแผลจากการบาดเจ็บหรือการผ่าตัด</li>
      </div>
      <div className="text-[#9E76B3] text-xl">
        ทีมสัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน{" "}
        <span className="drop-shadow-lg border-b">{menuSurgery[0].name}</span>:
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-5">
        {menuSurgery[0]?.vet.length > 0 &&
          menuSurgery[0].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover drop-shadow-lg w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const DataSurgery_2 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
        <span className="drop-shadow-lg">{menuSurgery[1].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาโรคกระดูกและข้อ: เช่น กระดูกหัก, ข้อสะโพกเสื่อม,
          และปัญหากระดูกสันหลัง
        </li>
        <li>
          การผ่าตัดกระดูก: เช่น การผ่าตัดกระดูกหัก, การผ่าตัดข้อเข่า,
          และการผ่าตัดข้อสะโพก
        </li>
        <li>
          การตรวจทางรังสีวินิจฉัย: เช่น การเอกซเรย์ (X-ray),
          การเอกซเรย์คอมพิวเตอร์ (CT Scan), และการส่องกล้องในการผ่าตัด
        </li>
        <li>
          การฟื้นฟูหลังการผ่าตัด: เช่น
          การทำกายภาพบำบัดและการใช้เครื่องมือช่วยเดิน
        </li>
        ทีมสัตวแพทย์ผู้เชี่ยวชาญที่ผ่านการอบรมด้านศัลยกรรมภาวะความผิดปกติของกระดูก
        พร้อมทีมงานที่มีประสบการณ์
        จะดูแลสัตว์เลี้ยงของคุณด้วยเครื่องมือและอุปกรณ์ที่ทันสมัย
        เพื่อให้การรักษาเป็นไปอย่างมีประสิทธิภาพและปลอดภัยที่สุด
      </div>
      <div className="text-[#9E76B3] text-xl">
        ทีมสัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน{" "}
        <span className="drop-shadow-lg border-b">{menuSurgery[1].name}</span>:
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-5">
        {menuSurgery[1]?.vet.length > 0 &&
          menuSurgery[1].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover drop-shadow-lg w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const DataSurgery_3 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
        <span className="drop-shadow-lg">{menuSurgery[2].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          การวางยาสลบ: โดยสัตวแพทย์วางยาสลบที่มีความเชี่ยวชาญ
          เพื่อให้การผ่าตัดเป็นไปอย่างปลอดภัยและมีประสิทธิภาพ
        </li>
        <li>
          อุปกรณ์ทางการแพทย์ที่ทันสมัย: เช่น เครื่องเอกซเรย์คอมพิวเตอร์ (CT
          Scan), เครื่องเอกซเรย์ระบบดิจิตอล, และเครื่องมือผ่าตัดที่ทันสมัย
        </li>
        <li>
          การดูแลภายหลังการผ่าตัด: ให้คำแนะนำในการดูแลสัตว์ป่วยหลังการผ่าตัด
          เช่น การจัดการแผลผ่าตัด, การให้ยา, และการฟื้นฟูสมรรถภาพ
        </li>
        ทีมสัตวแพทย์ที่มีประสบการณ์และความเชี่ยวชาญจะดูแลสัตว์เลี้ยงของคุณด้วยความเอาใจใส่และเครื่องมือที่ทันสมัย
        เพื่อให้การรักษาเป็นไปอย่างมีประสิทธิภาพและปลอดภัยที่สุด
      </div>
      <div className="text-[#9E76B3] text-xl">
        ทีมสัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน{" "}
        <span className="drop-shadow-lg border-b">{menuSurgery[2].name}</span>:
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-5">
        {menuSurgery[2]?.vet.length > 0 &&
          menuSurgery[2].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover drop-shadow-lg w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const DataSurgery_4 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
        <span className="drop-shadow-lg">{menuSurgery[3].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          การส่องกล้องตรวจทางเดินอาหาร: เช่น การตรวจหลอดอาหาร, กระเพาะอาหาร,
          และลำไส้เล็ก
          เพื่อวินิจฉัยโรคและเก็บตัวอย่างเนื้อเยื่อส่งตรวจทางห้องปฏิบัติการ
        </li>
        <li>
          การส่องกล้องตรวจทางเดินหายใจ: เช่น การตรวจหลอดลมและปอด
          เพื่อวินิจฉัยโรคและเก็บตัวอย่างเนื้อเยื่อส่งตรวจทางห้องปฏิบัติการ
        </li>
        <li>
          การส่องกล้องตรวจช่องหู:
          เพื่อวินิจฉัยโรคและเก็บตัวอย่างเนื้อเยื่อส่งตรวจทางห้องปฏิบัติการ
        </li>
        <li>
          การรักษาความผิดปกติที่พบ: เช่น การกำจัดสิ่งแปลกปลอม, การรักษาแผล,
          และการรักษาโรคที่พบจากการตรวจ
        </li>
        ทีมสัตวแพทย์ที่มีประสบการณ์และความเชี่ยวชาญจะดูแลสัตว์เลี้ยงของคุณด้วยเครื่องมือและอุปกรณ์ที่ทันสมัย
        เพื่อให้การรักษาเป็นไปอย่างมีประสิทธิภาพและปลอดภัยที่สุด
      </div>
      <div className="text-[#9E76B3] text-xl">
        ทีมสัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน{" "}
        <span className="drop-shadow-lg border-b">{menuSurgery[3].name}</span>:
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-5">
        {menuSurgery[3]?.vet.length > 0 &&
          menuSurgery[3].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover drop-shadow-lg w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};

export const DataSurgery_5 = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
    >
      <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
        <span className="drop-shadow-lg">{menuSurgery[4].name}</span>
      </div>

      <div className="flex flex-col justify-start gap-y-3 text-gray-500">
        <li>
          ตรวจวินิจฉัยและรักษาความผิดปกติทางทันตกรรมและแม็กซิลโลเฟเชียล: เช่น
          ฟันผุ, โรคเหงือก, และปัญหากระดูกขากรรไกร.
        </li>
        <li>
          การผ่าตัดทางทันตกรรมและแม็กซิลโลเฟเชียล: เช่น การผ่าตัดฟันคุด,
          การผ่าตัดกระดูกขากรรไกร, และการผ่าตัดแก้ไขความผิดปกติในช่องปาก.
        </li>
        <li>
          การตรวจทางรังสีวินิจฉัย: เช่น การเอกซเรย์ (X-ray),
          การเอกซเรย์คอมพิวเตอร์ (CT Scan), และการส่องกล้องในการผ่าตัด
        </li>
        <li>
          อุปกรณ์ทางการแพทย์ที่ทันสมัย: เช่น เครื่องเอกซเรย์ดิจิตอล,
          เครื่องมือผ่าตัดที่แม่นยำ และอุปกรณ์ทันตกรรมที่ทันสมัย.
        </li>
        <li>
          การดูแลภายหลังการผ่าตัด: ให้คำแนะนำในการดูแลสัตว์ป่วยหลังการผ่าตัด
          เช่น การจัดการแผลผ่าตัด, การให้ยา, และการฟื้นฟูสมรรถภาพ.
        </li>
        ทีมสัตวแพทย์ที่มีประสบการณ์และความเชี่ยวชาญจะดูแลสัตว์เลี้ยงของคุณด้วยความเอาใจใส่และเครื่องมือที่ทันสมัย
        เพื่อให้การรักษาเป็นไปอย่างมีประสิทธิภาพและปลอดภัยที่สุด
      </div>
      <div className="text-[#9E76B3] text-xl">
        ทีมสัตวแพทย์ที่เป็นผู้เชี่ยวชาญใน{" "}
        <span className="drop-shadow-lg border-b">{menuSurgery[4].name}</span>:
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2  gap-5">
        {menuSurgery[4]?.vet.length > 0 &&
          menuSurgery[4].vet.map((item, index) => (
            <>
              <div className="md:flex grid grid-cols-1 w-full lg:h-52 rounded-lg overflow-hidden shadow shadow-sky-200/50   gap-x-3">
                <div className="flex justify-center items-center">
                  <img
                    key={index}
                    src={item.img}
                    className="object-cover drop-shadow-lg w-52 h-full "
                    alt=""
                  />
                </div>
                <div className="flex flex-col  bg-[#9E76B3]/50 w-full px-3 py-3 gap-y-3">
                  <div className="font-semibold text-white flex gap-x-2 md:text-xl">
                    <span>{item.prefix}</span>
                    <span>{item.frist_name}</span>
                    <span>{item.last_name}</span>
                  </div>
                </div>
              </div>
            </>
          ))}
      </div>
    </motion.div>
  );
};
